/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropherouploaded2Inputs */

const en_dropherouploaded2 = /** @type {(inputs: Dropherouploaded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hero image uploaded`)
};

const de_dropherouploaded2 = /** @type {(inputs: Dropherouploaded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titelbild hochgeladen`)
};

/**
* | output |
* | --- |
* | "Hero image uploaded" |
*
* @param {Dropherouploaded2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropherouploaded2 = /** @type {((inputs?: Dropherouploaded2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropherouploaded2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropherouploaded2(inputs)
	return de_dropherouploaded2(inputs)
});
export { dropherouploaded2 as "dropHeroUploaded" }